<form class="content p-2" #searchForm="ngForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="row">
    @for (searchField of searchFields; track searchField) {
      <div class="col-auto">
        <label>
          <div>
            <strong>{{ searchField.placeholder }}: </strong>
          </div>
          <div>
            @if (searchField.name === 'claimIdentifierSubstring') {
              <input
                [(ngModel)]="captureSearchParams[searchField.name]"
                [id]="searchField.name"
                [name]="searchField.name"
                [type]="searchField.type"
                (ngModelChange)="onSearchFieldChanged()"
                class="form-control form-control-sm"
                #claimIdentifierSubstring="ngModel"
                minlength="4"
                />
              @if (claimIdentifierSubstring.invalid && (claimIdentifierSubstring.dirty || claimIdentifierSubstring.touched) && claimIdentifierSubstring.errors?.minlength) {
                <div class="text-danger">
                  4 character minimum.
                </div>
              }
            } @else {
              <input
                [(ngModel)]="captureSearchParams[searchField.name]"
                [id]="searchField.name"
                [name]="searchField.name"
                [type]="searchField.type"
                (ngModelChange)="onSearchFieldChanged()"
                class="form-control form-control-sm"
                />
            }
          </div>
        </label>
      </div>
    }
    <div class="col-auto">
      <div class="btn-group">
        <button type="submit" [disabled]="!canSearch || !searchForm.valid" class="btn btn-primary">Search</button>
        <button type="reset" (click)="onReset()" [disabled]="!canSearch" class="btn btn-info">Reset</button>
      </div>
    </div>
  </div>
</form>
@if (!refreshing && hasQueried && hasResults) {
  <div class="content mt-2">
    <ng-content />
    <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
  </div>
}
@if (!refreshing && hasQueried && !hasResults) {
  <div class="mt-2 ms-1">Can't find the patient you're looking for? Try searching on just the patient's last name. If you're still unable to find the patient you're looking for, please search using the specific claim ID (i.e. case number in your Walgreens portal). Any questions? Reach out to <strong><a href="mailto:{{ supportEmailAddress }}">{{ supportEmailAddress }}</a></strong>.</div>
}
@if (refreshing) {
  <div class="mt-2 ms-1"><mat-spinner diameter="30" /></div>
}
